import React from 'react';
import { IDeleteClientDialog } from './interfaces';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export const DeleteClientDialog: React.FC<IDeleteClientDialog> = ({
  show,
  clientName,
  disabled = false,
  onClose,
  onConfirm,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={show}>
      <DialogTitle fontWeight="bold">
        {t('clients:prompts.deleteClient.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans
            i18nKey="clients:prompts.deleteClient.body"
            components={{ strong: <strong /> }}
            values={{ clientName }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={disabled}>
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={disabled}
        >
          {t('buttons.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
